import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import { ArrowRight, Search, Smartphone } from "lucide-react";
import BrandMark from "@/components/BrandMark";
import { useLanding } from "./Landing";

export default function PublicLayout() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { data: L } = useLanding();

  const goToSchools = (e) => {
    e.preventDefault();
    if (pathname === "/") {
      document.getElementById("schools")?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/");
      setTimeout(() => document.getElementById("schools")?.scrollIntoView({ behavior: "smooth" }), 120);
    }
  };

  return (
    <div className="pub font-body">
      <header className="sticky top-0 z-40 border-b border-slate-200/70 bg-white/80 backdrop-blur-xl">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3.5">
          <Link to="/" className="flex items-center gap-3" data-testid="pub-home-link">
            <BrandMark size={30} />
            {L?.brand_sub ? (
              <>
                <span className="hidden h-7 w-px bg-slate-200 sm:block" />
                <span className="hidden max-w-[16rem] text-[13px] font-semibold uppercase leading-tight tracking-wide text-slate-500 sm:block">
                  {L.brand_sub}
                </span>
              </>
            ) : null}
          </Link>
          <nav className="flex items-center gap-1.5 sm:gap-3">
            <Link to="/app" className={`hidden items-center gap-1.5 rounded-full px-3.5 py-2 text-sm font-medium transition sm:inline-flex ${pathname === "/app" ? "bg-indigo-50 text-indigo-700" : "text-slate-600 hover:bg-slate-100"}`} data-testid="pub-getapp-link">
              <Smartphone size={15} /> Get the App
            </Link>
            <Link to="/track" className={`hidden items-center gap-1.5 rounded-full px-3.5 py-2 text-sm font-medium transition sm:inline-flex ${pathname === "/track" ? "bg-indigo-50 text-indigo-700" : "text-slate-600 hover:bg-slate-100"}`} data-testid="pub-track-link">
              <Search size={15} /> Track Application
            </Link>
            <Link to="/login" className="pub-btn !py-2 !px-4 text-xs sm:text-sm" data-testid="pub-login-link">
              Admin Login <ArrowRight size={15} />
            </Link>
          </nav>
        </div>
      </header>
      <Outlet />
      <footer className="border-t border-slate-200 bg-white">
        <div className="mx-auto max-w-7xl px-5 py-10">
          <div className="flex flex-col gap-8 sm:flex-row sm:items-start sm:justify-between">
            <div className="max-w-sm">
              <div className="flex items-center gap-3">
                <BrandMark size={26} />
                {L?.brand_sub ? (
                  <span className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">
                    {L.brand_sub}
                  </span>
                ) : null}
              </div>
              <p className="mt-3 text-sm leading-relaxed text-slate-500">
                {L?.hero_text?.slice(0, 130) ||
                  "One portal for admissions, fees, attendance and report cards."}
              </p>
            </div>
            <nav className="flex flex-col gap-2.5 text-sm">
              <p className="text-xs font-semibold uppercase tracking-wide text-slate-400">
                Quick links
              </p>
              <a href="/#schools" onClick={goToSchools} className="text-slate-600 transition hover:text-indigo-600">Browse schools</a>
              <Link to="/track" className="text-slate-600 transition hover:text-indigo-600">Track admission</Link>
              <Link to="/app" className="text-slate-600 transition hover:text-indigo-600">Get the Android app</Link>
              <Link to="/login" className="text-slate-600 transition hover:text-indigo-600">Staff &amp; admin login</Link>
            </nav>
          </div>
          <div className="mt-8 flex flex-col gap-2 border-t border-slate-200 pt-5 text-xs text-slate-400 sm:flex-row sm:items-center sm:justify-between">
            <p>© {new Date().getFullYear()} {L?.footer_text || "EduPulse Multi-School ERP."}</p>
            <p className="flex flex-wrap gap-x-3">
              {L?.contact_email ? <span>{L.contact_email}</span> : null}
              {L?.contact_phone ? <span>{L.contact_phone}</span> : null}
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
